import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { noop } from 'lodash';
import * as actions from '../../store/actions';
import { getPackageEntryClassNames } from '../../utils';
import Header from '../shared/Header';
import Filters from '../shared/Filters';
import FilterReviews from '../shared/FilterReviews';
import { ReviewsPagesCountInfo } from '../shared/ReviewsPagesCountInfo';
import FreelancerReviewsList from './FreelancerReviewsList';

import './FreelancerReviews.styles.scss';

const FreelancerReviews = ({ fetchReviews, onLoadMoreClick, onFilterChange }) => {
    const className = getPackageEntryClassNames('freelancer-reviews');

    return (
        <div className={className}>
            <Header
                title="reviews.header.freelancer"
                fetchReviews={fetchReviews}
                onFilterChange={onFilterChange}
                showSortFilters={false}
                showBreakdown
            />
            <div className="grid-12">
                <div className="col-12-sm col-8-md">
                    <Filters fetchReviews={fetchReviews} showSortFilters={false} />
                </div>
            </div>
            <div className="filter-pages-info m-t-8 p-t-24 flex flex-between flex-items-center">
                <ReviewsPagesCountInfo />
                <FilterReviews
                    className="flex flex-items-center p-b-20"
                    onFilterChange={onFilterChange}
                    fetchReviews={fetchReviews}
                />
            </div>
            <FreelancerReviewsList onLoadMoreClick={onLoadMoreClick} fetchReviews={fetchReviews} />
        </div>
    );
};

FreelancerReviews.defaultProps = {
    onLoadMoreClick: noop,
    onFilterChange: noop,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchReviews: actions.fetchReviews,
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(FreelancerReviews);
